import type { FallbackRender } from '@sentry/react';
import { Footer } from 'components/Footer/Footer';
import { Header } from 'components/Header/Header';
import { Heading } from 'components/Heading/Heading';
import { useFlysiteUrls } from 'hooks/useFlysiteUrls';
import { useNotFoundLogger } from 'hooks/useNotFoundLogger/useNotFoundLogger';
import { ReactComponent as RemoveCircle } from 'icons/remove-circle.svg';
import { useSelector } from 'react-redux';
import { getCurrentLocale } from 'selectors/ui/ui';
import { toError } from 'utils/errors/toError';
import { useTranslations } from 'utils/translations/useTranslations';

const Fallback = ({ error }: Parameters<FallbackRender>[0]) => {
  const i18n = useTranslations();
  const { pathname, search } = window.location;
  useNotFoundLogger(search, pathname, 'fallback', toError(error));
  const locale = useSelector(getCurrentLocale);
  const { supportUrl } = useFlysiteUrls(locale);

  return (
    <div>
      <Header />
      <main>
        <section className="flex flex-col items-center text-center justify-center w-auto mx-auto max-w-[576px] min-h-screen break-words py-8 px-2 lg:text-left lg:items-start lg:px-0">
          <RemoveCircle aria-hidden="true" focusable="false" />

          <Heading as="h1" size="huge" className="my-4 text-[32px]">
            {i18n.t('errorBoundryFallback.title')}
          </Heading>
          <p className="fontSize-lg marginBottom-sm">
            <span className="marginRight-xs">
              {i18n.t('errorBoundryFallback.description')}
            </span>
            <a href={supportUrl}>
              {i18n.t('errorBoundryFallback.contactSupport')}
            </a>
            .
          </p>
        </section>
      </main>
      <Footer />
    </div>
  );
};

export { Fallback };
